import { Component, OnInit, OnDestroy } from '@angular/core';
import { CookieService } from '@ngx-toolkit/cookie';
import { AvaliacaoApiService } from 'app/api/avaliacaoApi.service';
import { Avaliacao } from 'app/model/avaliacao';
import { SubSink } from 'subsink';
import Driver from 'driver.js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {

  avaliacoes: Avaliacao[];
  avaliados = new Array<any>();

  order = 'dataImportacao';
  reverse = true;

  checkCookie = false;
  disableTour = false;
  driver = new Driver({
    className: 'tour-lucor',
    doneBtnText: 'Entendi', // Text on the final button
    closeBtnText: 'Fechar', // Text on the close button for this step
    nextBtnText: 'Próximo', // Next button text for this step
    prevBtnText: 'Anterior', // Previous button text for this step
  });

  private subs = new SubSink();

  constructor(
    private avaliacoesService: AvaliacaoApiService,
    private cookieService: CookieService) {}

  ngOnInit() {
    this.checkCookie = this.cookieService.hasItem('tourHome');
    this.getAvaliacoes();
  }

  startTour(): void {
    this.disableTour = true;
    // Define the steps for tour
    setTimeout(() => {
      this.driver.defineSteps([
        {
          element: '#one-element-tour',
          popover: {
            className: 'first-step-popover-class',
            title: 'Vamos fazer um tour?',
            description: 'Você pode usar as teclas <i class="fas fa-caret-left icon-tour"></i> e <i class="fas fa-caret-right icon-tour"></i> para avançar e voltar. Acesse aqui sempre que precisar.',
            position: 'left',
            closeBtnText: 'Eu vejo depois.',
            nextBtnText: 'Vamos lá!',
            prevBtnText: '<i class="fas fa-plane-departure"></i>'
          }
        },
        {
          element: '#dois-element-tour',
          popover: {
            title: 'Avaliações cadastradas',
            description: 'As avaliações são os "bancos de dados" dos avaliados que responderam a ferramenta de análise comportamental.',
            position: 'right'
          }
        },
        {
          element: '#tres-element-tour',
          popover: {
            title: 'Mapeamento',
            description: 'Aqui você tem acesso a todas as informações dos avaliados. Os dados estarão disponíveis em números e gráficos, tanto do indíviduo quanto do grupo.',
            position: 'left'
          }
        },
        {
          element: '#quatro-element-tour',
          popover: {
            title: 'Diagnóstico NR 1',
            description: 'Esta é a área onde você poderá criar perfis e gerenciar os Diagnósticos NR 1.<br> Ao associar uma avalição ao Diagnóstico NR 1 já é possível visualizar os dados de adequação.',
            position: 'left'
          }
        },
        {
          element: '#cinco-element-tour',
          popover: {
            title: 'Cargos',
            description: 'Esta é a área onde você poderá criar perfis para cargos ou programas.<br> Ao associar uma avalição ao perfil criado já é possível visualizar o ranking de aproximação.',
            position: 'right'
          }
        },
        {
          element: '#seis-element-tour',
          popover: {
            title: 'Cargos Modelo',
            description: 'Cargos e perfis de referência para criação de novos perfis para cargos ou programas.',
            position: 'right'
          }
        },
        {
          element: '#sete-element-tour',
          popover: {
            title: 'Perfis Clone',
            description: 'Visualize um perfil clone gerado a partir de outros perfis de referência e crie cargos com os perfis clonados.',
            position: 'left'
          }
        },
        {
          element: '#oito-element-tour',
          popover: {
            title: 'Integrações',
            description: 'Onde você faz a gestão das de seus tokens de integração para utilização em sistemas parceiros.',
            position: 'right'
          }
        },
        {
          element: '#nove-element-tour',
          popover: {
            title: 'Ciências',
            description: 'Catálogo contendo todos os atributos e definições de cada ciência.',
            position: 'right'
          }
        },
        {
          element: '#dez-element-tour',
          popover: {
            title: 'Atendimento',
            description: 'Contato direto com nossos especialistas que irão tirar suas dúvidas.',
            position: 'left'
          }
        },
      ]);
      // Start the introduction
      this.driver.start();
      this.disableTour = false;
    }, 2000);
  }

  setCookie() {
    this.cookieService.setItem( 'tourHome', '1' );
  }


  getAvaliacoes(): void {
    this.subs.sink = this.avaliacoesService.v1AvaliacaoGet()
      .subscribe(avaliacoes => {
        this.avaliacoes = avaliacoes; 

        // console.log(this.avaliacoes);

        setTimeout(() => {
          if (!this.checkCookie) {
              this.startTour();
              this.setCookie();
          }
        }, 4000);
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
